<template>
  <div ref="colorModel" class="color-model">
    <div class="color-model__header">
      <im-select v-model="type" :options="typeOptions" size="small" @change="onChangeType"/>
      <i class="el-icon-close" @click="handleClose"/>
    </div>
    <div class="color-model__content">
      <quick-gradient v-if="isPickQuickColor" @select="onQuickSelect"/>
      <gradient v-else-if="type === 'gradient'" ref="gradient" v-model="color" :parent-rect="rect" class="mb-3" @cancel="onGradientCancel" @change="onGradientChange" @pure-change="onGradientPureChange"/>
      <pure v-if="type === 'pure'" v-model="color" @change="onPureChange"/>
    </div>
    <color-transform v-if="!isPickQuickColor" :value="transformValue"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import colorTransform from './transform.vue'
import QuickGradient from './quick.vue'
import gradient from './gradient'
import pure from "./pure";

export default {
  components: {
    gradient,
    colorTransform,
    pure,
    QuickGradient
  },
  props: {
    value: [String],
    solidColor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: '',
      color: '',
      quickColor: '',
      transformValue: '',
      rect: {
        bottom: null,
        height: null,
        left: null,
        right: null,
        top: null,
        width: null,
        x: null,
        y: null
      }
    }
  },
  computed: {
    ...mapGetters(['recentColors']),
    isPickQuickColor() {
      return this.type === 'gradient' && !this.color?.includes('linear')
    },
    typeOptions() {
      const result = [
        {
          label: '纯色',
          value: 'pure'
        },
        {
          label: '渐变',
          value: 'gradient'
        }
      ]
      if (this.solidColor) {
        result.splice(1, 1)
      }
      return result
    }
  },
  watch: {
    value(n) {
      this.color = n
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // handleClickRecent(value) {
    //   if (this.type === 'pure') {
    //     this.color = value
    //     this.emitValue(value)
    //   } else if (this.type === 'gradient') {
    //     this.$refs.gradient.setCurrentValue(value)
    //   }
    // },
    init() {
      const rect = this.$refs.colorModel.getBoundingClientRect()
      for (const key in rect) {
        if (Object.prototype.hasOwnProperty.call(this.rect, key)) {
          this.rect[key] = rect[key]
        }
      }
      this.initValue()
    },
    onChangeType() {
      this.color = this.value
    },
    initValue() {
      this.transformValue = this.value
      this.color = this.value
      this.getValueType()
    },
    getValueType() {
      const linearKey = 'linear'
      const isLinear = this.value.includes(linearKey)
      if (isLinear) {
        this.type = 'gradient'
      } else {
        this.type = 'pure'
      }
    },
    handleClose() {
      this.$emit('close')
    },
    emitValue(value) {
      this.$emit('change', this.type, value)
    },
    onGradientPureChange(value) {
      this.transformValue = value
    },
    onGradientChange(value) {
      this.transformValue = value
      this.emitValue(value)
    },
    onGradientCancel() {
      this.color = ''
      this.emitValue('')
    },
    onQuickSelect(item) {
      this.color = item.color
      this.transformValue = item.color
      this.emitValue(item.color)
    },
    onPureChange(value) {
      this.transformValue = value
      this.emitValue(value)
    }
  }
}
</script>

<style lang="less">
.color-model {
  // background: var(--bg-color-overlay);
  // backdrop-filter: blur(20px);
  // -webkit-backdrop-filter: blur(20px);
  // border: 1px solid var(--border-color-base);
  // box-shadow: var(--shadow-lg);
  // border-radius: 12px;
  width: 240px;
  overflow: hidden;

  .vc-chrome-fields-wrap {
    display: none;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid var(--border-color-base);

    .im-select {
      width: 100px;
      
      .el-input__inner {
        background-color: var(--bg-color-base);
        border: 1px solid transparent;
        color: var(--text-color);
        height: 28px;
        line-height: 28px;
        border-radius: 6px;
        font-size: 12px;
        padding-left: 8px;
        padding-right: 24px;
        
        &:hover {
          background-color: var(--bg-color-hover);
        }
        
        &:focus {
           background-color: var(--bg-color-hover);
           border-color: var(--primary-color);
        }
      }
      
      .el-input__icon {
        line-height: 28px;
      }
    }

    .el-icon-close {
      font-size: 16px;
      color: var(--text-secondary);
      transition: all 0.3s;
      cursor: pointer;
      
      &:hover {
        color: var(--text-color);
        transform: rotate(90deg);
      }
    }
  }
  
  &__content {
    padding: 16px;
  }

  &__recent {
    .color-item {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid var(--border-color-base);
      cursor: pointer;
      transition: transform 0.2s;
      
      &:hover {
          transform: scale(1.1);
          border-color: var(--text-color);
      }
    }
  }
}
</style>
